import { Form, InputGroup } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { AiOutlineDelete } from "react-icons/ai";
import { FaCircleXmark, FaPlus } from "react-icons/fa6";
import { Button, Checbox, Input } from "../CustomComponents";
import LoadingButton from "../CustomComponents/LoadingButton";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useEffect } from "react";

const AddQuestionModal = ({
  handleModalClose,
  heading,
  data,
  isLoading,
  onSubmit = () => {},
}) => {
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      type: 20,
      options: [{ option: null }],
    },
  });
  console.log(data, "data");

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "options",
    }
  );
  const type = watch("type");

  const SelectField = [
    { value: 10, label: "Single Select" },
    { value: 20, label: "Multi Select" },
    { value: 30, label: "Text" },
  ];
  useEffect(() => {
    console.log(data?.is_required);

    if (data) {
      setValue("question", data?.question);
      setValue("type", data?.type);
      setValue("is_required", data?.is_required == 1 ? true : false);
      setValue("options", data?.options);
      setValue("value", data?.value);
    }
  }, [data]);
  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <p className="fs-4 fw-medium m-0">{heading}</p>
            <span className="bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                size={25}
                role="button"
                onClick={handleModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)} className="w-100">
            <Controller
              control={control}
              name="question"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <InputGroup className="mb-3">
                  <Input
                    placeholder="Question"
                    type="text"
                    onChange={onChange}
                    value={value}
                  />
                </InputGroup>
              )}
            />
            <Controller
              control={control}
              name="value"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <InputGroup className="mb-3">
                  <Input
                    placeholder="Value"
                    type="text"
                    onChange={onChange}
                    value={value}
                  />
                </InputGroup>
              )}
            />
            <Controller
              control={control}
              name="is_required"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Checbox label="Required" onChange={onChange} value={value} />
              )}
            />
            <Controller
              control={control}
              name="type"
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <>
                  <SelectFieldComponent
                    value={value}
                    optionsList={SelectField}
                    onChange={onChange}
                    className="w-100"
                  />
                </>
              )}
            />
            <div className="flex-between w-100">
              <p className="my-3 fw-bold">Options</p>
              {(type == 20 || type == 30) && (
                <FaPlus
                  color="black"
                  className="cursor-pointer"
                  size={30}
                  onClick={append}
                />
              )}
            </div>

            {fields.map((field, index) => (
              <div
                key={field.id}
                className="w-100 d-flex gap-2 align-items-center"
              >
                <Controller
                  control={control}
                  name={`options.${index}.option`}
                  render={({ field }) => (
                    <InputGroup className="mb-3 w-100">
                      <Input
                        placeholder={`Option ${index + 1}`}
                        type="text"
                        {...field}
                      />
                    </InputGroup>
                  )}
                />
                <AiOutlineDelete
                  role="button"
                  onClick={() => remove(index)}
                  size={20}
                  color="red"
                  className="cursor-pointer"
                />
              </div>
            ))}

            <Button
              text={
                <>{isLoading ? <LoadingButton /> : data ? "Update" : "Add"}</>
              }
              classes="mt-3 mb-2"
              type="submit"
            />
          </Form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddQuestionModal;
